export const SET_VMS_TABLE = "SET_VMS_TABLE"
